import MarketTabModel from './model-market-tab';

/**
 * Market model
 */
export default class MarketModel {
  /**
   * Class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Market ID
     * @type {number}
     */
    this.id = data.id;
    /**
     * True if market is scorecast
     * @type {boolean}
     */
    this.isScorecast = data.is;
    /**
     * Market name
     */
    this.name = data.n;
    /**
     * Market tabs
     */
    this.tabs = data.o ? Object.entries(data.o).map(d => new MarketTabModel(d)) : [];
  }
}
